<template>
  <div class="resetPassword">
    <div class="header">
      <div class="logo">
        <img
          src="@/assets/icons/logo.jpg"
          alt="logo"
        >
      </div>
    </div>
    <div class="line" />
    <div class="loginBox">
      <!-- <div class="loginBox_left">
        <a-menu
          :default-selected-keys="['1']"
          :default-open-keys="['sub1']"
          mode="inline"
          theme="dark"
          :inline-collapsed="collapsed"
        >
          <a-menu-item key="1">
            <svg-icon icon-class="yonghu" />
            <span>{{ $t('login/login') }}</span>
          </a-menu-item>
          <a-menu-item
            key="2"
            @click="goRegister"
          >
            <svg-icon icon-class="bibianji" />
            <span>{{ $t('login/register') }}</span>
          </a-menu-item>
        </a-menu>
      </div> -->
      <div class="content">
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          label-align="left"
        >
          <a-form-model-item
            ref="account"
            prop="account"
            :help="errorMsg"
            :validate-status="validateStatus"
            style="margin-bottom: 64px;"
            class="account"
          >
            <div class="ant-col ant-form-item-label ant-form-item-label-left">
              <label :title="$t('login-forget/phone')" class="ant-form-item-required" v-html="$t('login-forget/phone')" />
            </div>
            <a-input
              v-model="form.account"
              @change="accountChange"
            />
          </a-form-model-item>
          <a-form-model-item
            ref="code"
            :label="$t('view-components-components/Captcha')"
            prop="code"
          >
            <div style="display: flex;">
              <a-input v-model="form.code" size="large" />
              <a-button size="large" type="primary" :disabled="!!countTxt" @click="sendCode">{{ $t('register-verify/send') + countTxt }}</a-button>
            </div>
          </a-form-model-item>
          <a-form-model-item
            ref="password"
            :label="$t('user-account-password/new')"
            prop="password"
          >
            <a-input-password
              v-model="form.password"
            />
          </a-form-model-item>
          <a-form-model-item
            ref="password_confirmation"
            :label="$t('user-account-password/reEnter')"
            prop="password_confirmation"
          >
            <a-input-password
              v-model="form.password_confirmation"
            />
          </a-form-model-item>
          <a-form-model-item
            :wrapper-col="{ offset: 0 }"
            style="margin-bottom: 0;"
          >
            <a-button
              style="background: #f8f8f8;"
              @click="onSubmit"
            >
              <a-icon type="up" />
              <span style="margin-left: 3px;">{{ $t('register-verify/submit') }}</span>
            </a-button>
            <a-button
              style="background: #f8f8f8;margin-left: 20px;"
              @click="goLogin"
            >
              <svg-icon icon-class="yonghu" />
              <span style="margin-left: 3px;">{{ $t('login-forget/goLogin') }}</span>
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
import { userFindPassword, userSendCode } from '@/api/login'
import zh from '@/lang/zh.json'
import en from '@/lang/en.json'
import { getLKey } from '@/utils/auth'

const i18n = { zh, en }
const lang = getLKey()

export default {
  name: 'ForgetPassword',
  data() {
    return {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      collapsed: false,
      form: {
        account: '',
        code: '',
        type: '1',
        password: '',
        password_confirmation: ''
      },
      rules: {
        code: [
          { required: true, message: i18n[lang]['view-components-components/Captcha'], trigger: ['change', 'blur'] },
          { len: 4, message: i18n[lang]['view-components-components/CaptchaLength'], trigger: ['change', 'blur'] }
        ],
        account: [
          { required: true, message: i18n[lang]['view-resetPassword/accountRequired'], trigger: ['change', 'blur'] }
        ],
        password: [
          { required: true, message: i18n[lang]['admin-password-password/please-enter'], trigger: ['change', 'blur'] },
          { min: 8, message: i18n[lang]['admin-password-password/8-bit'], trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true, message: i18n[lang]['register/rePassword'], trigger: ['change', 'blur'] },
          { validator: (rule, value, callback) => {
            if (value !== this.form.password) {
              callback(new Error(i18n[lang]['admin-password-password/different-passwords']))
            } else {
              callback()
            }
          }, trigger: 'blur'
          }
        ]
      },
      countTxt: '',
      errorMsg: '',
      validateStatus: ''
    }
  },
  created() {
  },
  methods: {
    sendCode() {
      if (this.validateStatus === 'error') {
        return this.$message.warning({ content: this.$t('view-components-components/mailError'), key: 'message', duration: 4 })
      }
      userSendCode({ phone: this.form.account, type: 2 }).then(res => {
        this.$message.success({ content: this.$t('view-components-components/send'), key: 'message', duration: 4 })
        this.countDown()
      })
    },
    countDown() {
      let t = 60
      this.countTxt = '(' + t + ')'
      const timer = setInterval(() => {
        if (t !== 0) {
          this.countTxt = '(' + --t + ')'
        } else {
          this.countTxt = ''
          clearInterval(timer)
        }
      }, 1000)
    },
    accountChange(e) {
      if (!e.target.value) {
        this.errorMsg = this.$t('view-components-components/phoneError')
        this.validateStatus = 'error'
      } else {
        const phoneReg = /^1\d{10}$/
        if (phoneReg.test(e.target.value)) {
          this.validateStatus = undefined
          this.errorMsg = ''
        } else {
          this.validateStatus = 'error'
          this.errorMsg = this.$t('view-components-components/phoneError')
        }
      }
    },
    onSubmit() {
      const that = this
      this.$refs.ruleForm.validate(valid => {
        if (valid && this.validateStatus !== 'error') {
          const data = {
            code: that.form.code,
            type: '1',
            password: that.form.password,
            password_confirmation: that.form.password_confirmation,
            phone: that.form.account
          }
          userFindPassword(data).then(res => {
            that.$message.success({ content: this.$t('admin-rewards-rewards/modify'), key: 'message', duration: 4 })
          })
        } else {
          this.$message.warning({ content: this.$t('view-components-components/perfect'), key: 'message', duration: 4 })
          console.log('error submit!!')
          return false
        }
      })
    },
    goLogin() {
      this.$router.push({ path: '/login' })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    goRegister() {
      this.$router.push({ path: '/register' })
    }
  }
}
</script>
<style lang="less" scoped>
.resetPassword{
  margin: 0 auto;
  width: 600px;
}
.login {
  margin: 0 185px 0;
  padding-top: 34px;
  min-width: 700px;
  font-size: 18.65px;
}

.tools {
  float: left;
  margin-top: 15.37vh;
}

.logo {
 text-align: center;
}

.logo img{
  height: 30vh;
  width: 30vh;
}

.line {
  width: 100%;
  height: 2px;
  clear: both;
  padding-top: 21px;
  background: #333333;
  background-clip: content-box;
  box-sizing: content-box;
}

.line2 {
  width: 100%;
  height: 1px;
  padding-top: 70px;
  background: #eeeeee;
  background-clip: content-box;
  box-sizing: content-box;
}

.loginBox {
  margin-top: 57px;
  display: flex;
}

.loginBox_left {
  max-width: 295px;
  flex: 1;
}

.loginBox_right {
  width: 261px;
  height: 332px;
  padding: 52px 0 74px 28px;
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
}

.loginBox_right p {
  font-family: "PingFangSC-Regular";
  font-size: 14px;
  overflow: hidden;
  margin: 0;
}

.loginBox .ant-menu {
  background: #ffffff;
  color: #333333;
}

.loginBox .ant-menu-item {
  color: #333333;
  font-size: 18.65px;
  margin: 0;
}

.loginBox .ant-menu-item svg {
  margin-right: 10px;
}

.loginBox .ant-menu-item svg + span {
  opacity: 1;
  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.loginBox .ant-menu-item-selected svg,
.loginBox .ant-menu-item-selected svg + span {
  color: #fff;
}

.content {
  flex: 2;
  padding: 0 50px;
}

.forgetPwd {
  color: #999999;
  cursor: pointer;
}
</style>
<style>
.resetPassword .ant-form label {
  font-size: 18.65px;
}

.resetPassword .ant-form-horizontal .ant-form-item-with-help.account {
  margin-bottom: 64px !important;
}
</style>
